export const API_CONFIG_V2 = {
  BASE_URL: import.meta.env.VITE_BASE_URL,
  ENDPOINTS: {
    SEND_OTP: '/auth/identity/email',
    VERIFY_OTP: '/auth/identity/confirm',
    CERT: '/auth/cert',
    REISSUE: '/auth/reissue',
    GET_MAIN_BLOCK: '/auth/main-block',
    UPLOAD_PHOTO: '/photo/upload',
    AI_SERVER_CHECK: '/ai-server-check',
    GET_QR: '/photo/qr',
    AI_MODEL: '/photo/ai',
    PREPARE_PAYMENT: '/pay/prepare',
    CONFIRM_PAYMENT: '/pay/confirm',
    CANCEL_PAYMENT: '/pay/cancel',
    ANALYTICS_START_BUTTON: '/analytics/start-button',
    ANALYTICS_READY_BUTTON: '/analytics/ready-button',
    ANALYTICS_EXIT_REASON: '/analytics/exit-reason',
    ANALYTICS_FRAME: '/analytics/frame',
    ANALYTICS_EMAIL: '/analytics/email',
  },
  HEADERS: {
    'Content-Type': 'application/json',
  },
};
